import {Dimensions, StyleSheet} from 'react-native';
export const styles = StyleSheet.create({
  parentBox: {
    padding: 15,
    gap: 15,
  },
  align: {
    textAlign: 'left',
  },
  cta: {
    borderRadius: 100,
  },
  input: {
    marginTop: 5,
  },
  inputContainer: {
    width: '100%',
    borderRadius: 15,
    marginTop: 10,
  },
  divider: {
    marginVertical: 15,
    flex: 1,
    marginLeft: -20,
    width: Dimensions.get('screen').width,
  },
  flatList: {
    flexGrow: 0,
  },
  barcodeCountBox: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 30,
    gap: 5,
    alignItems: 'center',
  },
  image: {
    height: 35,
    width: 35,
    borderWidth: 2,
    borderRadius: 100,
  },
  storeBox: {
    gap: 5,
  },
});
